const pagesSettingsAuthenticationEn = {
  accessRules: {
    description: 'Configure login methods and authentication requirements per audience.',
    title: 'Access rules'
  },
  authPolicies: {
    description: 'Define authentication requirement policies and apply them from access rules.',
    title: 'Authentication policies'
  },
  settings: {
    authenticationMethod: {
      comingSoonBadge: 'Coming soon',
      description: 'Configure authentication methods for the organization.',
      title: 'Authentication method'
    },
    navigation: {
      authenticationMethod: 'Authentication method',
      label: 'Settings',
      password: 'Password',
      session: 'Session rules',
      sso: 'SSO'
    },
    sso: {
      actions: {
        configure: 'Configure',
        edit: 'Edit'
      },
      card: {
        title: 'SSO delegation'
      },
      columns: {
        actions: 'Actions',
        delegationTarget: 'Delegation target (one)',
        protocol: 'Protocol',
        provider: 'External IdP (source)',
        status: 'Status'
      },
      delegationAriaLabel: 'Set {{provider}} as the delegation target',
      description: 'Configure which identity provider handles authentication for your organization.',
      heading: 'SSO — Source IdP',
      loadError: 'Failed to load SSO settings.',
      native: {
        alwaysFallback: 'Always available',
        membershipIndividual: 'Member',
        membershipOperator: 'Staff',
        notDelegatable: 'Cannot be a delegation target (always available)',
        passwordAllowed: 'Password login: {{types}}',
        passwordDenied: 'Password login disabled',
        protocolMfa: 'MFA',
        protocolPassword: 'Password',
        title: 'DRESS CODE native'
      },
      retry: 'Retry',
      status: {
        activeDelegation: 'Active (delegated)',
        disabled: 'Disabled',
        nativeFallback: 'Active',
        notConfigured: 'Not configured'
      },
      title: 'SSO',
      toast: {
        connectionDeleted: 'SSO connection deleted',
        connectionSaved: 'SSO connection saved',
        delegationUpdated: 'SSO delegation updated'
      }
    }
  },
  tabs: {
    accessRules: 'Access rules',
    authPolicies: 'Authentication policies',
    settings: 'Settings'
  },
  title: 'Authentication'
};
export default pagesSettingsAuthenticationEn;